<template>
  <div class="students" v-show="show">
    <div class="stu-header">
      <div>昵称/id</div>
      <div>学习时长</div>
      <div>打卡次数</div>
    </div>
    <div class="stu-list">
      <van-list
        v-model="loading"
        :finished="finished"
        offset="50"
        :immediate-check="false"
        @load="handlerLoad"
      >
        <div class="stu-card" v-for="item in list" :key="item.id">
          <div class="stu-info">
            <div class="avatar"><img :src="item.portrait" alt="avatar"></div>
            <div class="detail-info">
              <div class="name">{{item.nickname}}</div>
              <div class="user-id">{{item.id}}</div>
            </div>
          </div>
          <div class="common time">{{item.study_time}}</div>
          <div class="common">{{item.punch_count}}</div>
        </div>
        <div class="empty" v-if="list.length === 0">
          <img src="@/assets/my-clock-in-empty.png" alt="" class="empty-img">
          <div class="empty-text">请先在crm后台绑定班级群</div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { List } from 'vant';
import { ref, watch } from '@vue/composition-api';
import { getStudents } from '@/api/clockin';
import { resizeAlcdnUrl } from '@/common/js/utils';

export default {
  props: {
    classId: {
      type: Number,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [List.name]: List,
  },
  setup(props) {
    const loading = ref(false);
    const finished = ref(false);
    const list = ref([]);
    const limit = ref(15);
    const offset = ref(0);
    const isReq = ref(false);

    /**
     * @description 加载学员列表
     */
    const handlerLoad = () => {
      if (isReq.value) {
        return;
      }

      isReq.value = true;
      const data = {
        classId: props.classId,
        limit: limit.value,
        offset: offset.value
      };

      getStudents(data).then((res) => {
        loading.value = false;
        isReq.value = false;

        const users = res.items.map((item) => {
          const avatar = resizeAlcdnUrl(item.portrait, 28);

          if (item.study_time) {
            let timeText = '';

            const hours = Math.floor(item.study_time / 3600);
            if (hours > 0) {
              timeText = `${hours}时`;
            }

            const minutes = Math.floor((item.study_time - hours * 3600) / 60);
            if (minutes > 0) {
              timeText += `${minutes}分`;
            }

            item.study_time = timeText;
          }

          return {
            ...item,
            portrait: avatar
          };
        });

        list.value.push(...users);
        offset.value = list.value.length;

        if (users.length < data.limit) {
          finished.value = true;
        }
      }).catch(() => {
        loading.value = false;
        isReq.value = false;
      });
    };

    watch(() => props.show, (val) => {
      if (!val) {
        return;
      }

      if (list.value.length > 0) {
        return;
      }

      handlerLoad();
    }, { immediate: true });

    return {
      loading,
      finished,
      list,
      handlerLoad
    };
  },
};
</script>

<style lang="stylus" scoped>
.stu-header {
  display: flex;
  align-items: center;
  justify-content space-between
  padding: 0 20px 0 16px;
  width: 100%;
  height: 36px;
  background: #F6F7FA;
  font-size: 14px;
  color: #999;
}

.stu-list {
  position relative
  margin-left: 16px;
}

.stu-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  width: 100%;
  height: 57px;
  border-bottom: 0.5px solid #e7e7e7;

  .common {
    font-size: 12px;
    color: #191919;
  }

  .time {
    position: absolute;
    top: 22px;
    left: calc(50% - 44px);
    min-width 56px
    text-align center
  }

  .stu-info {
    display: flex;
    align-items: center;
    width: calc((100% - 195px) / 2 + 27px)

    .avatar {
      width: 28px;
      height: 28px;
      background: url('../../../common/images/default.jpg');
      background-size: 28px 28px;
      border-radius: 50%;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .detail-info {
      margin-left: 6px;
      width: calc(100% - 34px)
    }

    .name {
      overflow hidden
      height: 14px;
      font-size: 12px;
      color: #191919;
      line-height: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }

    .user-id {
      margin-top: 4px;
      width: 100%;
      font-size: 12px;
      color: #999;
      transform: scale(0.8) translateX(-12%);
    }
  }
}

.empty {
  position absolute
  top 109px
  left 50%;
  transform translateX(-50%)

  .empty-img {
    width 255px
    height 168px
  }

  .empty-text {
    margin-top 13px
    width 100%
    text-align center
    font-size 14px
    color #999
  }
}
</style>
